export default {
  path: '/flash',
  component: () => import('@/views/flash/index.vue'),
  children: [
    {
      path: 'request-log',
      name: 'FlashRequestLog',
      component: () => import('@/views/flash/pages/RequestLog.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'support'
        ]
      }
    },
    {
      path: 'webhook-log',
      name: 'FlashWebhookLog',
      component: () => import('@/views/flash/pages/WebhookLog.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'support'
        ]
      }
    }
  ]
}
